import script from "./ModalDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalDialog.vue?vue&type=script&setup=true&lang=ts"

import "./ModalDialog.vue?vue&type=style&index=0&id=1034249f&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1034249f"]])

export default __exports__